"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function WidgetIcon(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { height: "".concat(height), viewBox: "0 0 96 96", className: "".concat(className), width: "".concat(width) },
        React.createElement("path", { d: "M15.702 3.858C26.468 1.286 37.234 0 48 0c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0111.844 11.844C94.714 26.468 96 37.234 96 48c0 10.766-1.286 21.532-3.858 32.298a16 16 0 01-11.844 11.844C69.532 94.714 58.766 96 48 96c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 013.858 80.298C1.286 69.532 0 58.766 0 48c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0115.702 3.858z", fill: "#009CFF" })));
}
WidgetIcon.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
WidgetIcon.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = WidgetIcon;
